export function fmtCents(cents) {
  if (cents === null || cents === undefined) return "—";
  const n = Number(cents) / 100;
  return n.toLocaleString("en-AU", {
    style: "currency",
    currency: "AUD",
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export const CURRENCY_CODE = "AUD";

export function fmtAreaSqm(value) {
  const area=Number(value);
  if(value==null||!Number.isFinite(area)||area<=0)return "Not available";
  if(area<0.000001)return "<0.000001 m²";
  return `${area.toLocaleString("en-AU",{minimumFractionDigits:3,maximumFractionDigits:6})} m²`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

export function daysAgo(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  return Math.floor((Date.now() - then) / 86_400_000);
}
